/**
 * Wildfool Free Gift Auto-Add v13
 * ---------------------------------------------------------
 * Highest-tier-only gift policy:
 *   $54-$99.99   -> Beechwood Comb (Raw)
 *   $100-$198.99 -> Dachshund Hair Clip (Pink Bow)
 *   $199-$298.99 -> Silk Scrunchie (Black)
 *   $299+        -> Silk Sleep Mask (Black)
 *
 * Only one automatic gift should be in the cart at a time. Higher tiers
 * replace lower-tier gifts to protect margin and keep checkout clear.
 *
 * v14: customer removal is final for the session (no re-add loop), and a
 * gift line that is not actually free (discount threshold mismatch in
 * presentment currency) is pulled back out instead of charging the buyer.
 *
 * v15: tiers qualify on the DISCOUNTED spend (what the buyer actually
 * pays), matching how Shopify evaluates the native gift discounts:
 * Bundle 20% is assumed at $220+, otherwise the discount_code cookie
 * rate (WILDFOOL10 etc.) is applied. No discount cookie = full price.
 */
(function () {
  var GIFT_PROP_KEY = "_wildfool_gift";
  var VERSION = "v15.6-activeline";
  var THRESHOLD_POLICY = "shop-thresholds-54-199-299-client-currency";
  var FREE_SHIPPING_THRESHOLD = 10000;
  var BUNDLE_SUBTOTAL_THRESHOLD = 22000; // WF: $220 USD subtotal (own items, excl gift+SP)
  // v14: only auto-add when comfortably past the discount threshold, so
  // presentment-currency rounding can never leave the gift undiscounted.
  var ADD_MARGIN = 200; // $2 USD

  var TIERS = [
    { key: "comb",      threshold: 5400,  variantId: 52995158737261, name: "Comb",      value: 1200 },
    { key: "dachshund", threshold: 10000, variantId: 53511164068205, name: "Dachshund Clip", value: 1000 },
    { key: "scrunchie", threshold: 19900, variantId: 52995157950829, name: "Scrunchie", value: 2200 },
    { key: "mask",      threshold: 29900, variantId: 52995161981293, name: "Mask",      value: 3800 }
  ];

  var GIFT_VARIANTS = TIERS.map(function (t) { return t.variantId; });
  var OPEN_LOCK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 11V7a4 4 0 0 1 7.5-2" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><rect x="4" y="11" width="14" height="10" rx="2" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CLOSED_LOCK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 11V7a4 4 0 1 1 8 0v4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var syncing = false;
  var lastSync = 0;
  var syncPromise = null;
  var debugLogged = false;
  var checkoutGuardBypass = false;
  var cartDirty = false; // v15.5: true while a cart mutation awaits gift sync
  // Await the actual cart writes before gift reconciliation / checkout.
  var pendingCartWrites = new Set();
  var cartWriteVersion = 0;
  var lastCartWriteError = null;
  var checkoutPending = false;
  var lastCartItems = null;
  // v15.2: shared cart cache + observer handle. Without these the rewards
  // re-render loop fired one /cart.js per DOM mutation (19 requests per add).
  var mo = null;
  var rerenderBusy = false;
  var lastCartFetch = 0;
  var lastCartData = null;

  function giftDismissed() {
    try { return sessionStorage.getItem("wf_gift_dismissed") === "1"; } catch (e) { return false; }
  }
  function setGiftDismissed() {
    try { sessionStorage.setItem("wf_gift_dismissed", "1"); } catch (e) {}
    log("gift removed by customer; auto-add off for this session");
  }
  function priceHold() {
    try { return JSON.parse(sessionStorage.getItem("wf_gift_price_hold") || "{}"); } catch (e) { return {}; }
  }
  function setPriceHold(variantId, shopTotal) {
    try {
      var h = priceHold();
      h[variantId] = shopTotal;
      sessionStorage.setItem("wf_gift_price_hold", JSON.stringify(h));
    } catch (e) {}
  }
  function heldAtCurrentTotal(variantId, shopTotal) {
    var h = priceHold();
    return h[variantId] != null && shopTotal <= h[variantId];
  }

  function log() {
    try {
      var args = ["[WF gift " + VERSION + "]"].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    } catch (e) {}
  }


  function activeCurrency() {
    try {
      var currency = window.Shopify && window.Shopify.currency;
      var c = currency && currency.active;
      var r = currency && parseFloat(currency.rate);
      if (c && (c === "USD" || (r && r > 0))) return c;
      return "USD";
    } catch (e) {
      return "USD";
    }
  }

  function formatCurrencyUnits(value, fractionDigits) {
    var currency = activeCurrency();
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      }).format(value);
    } catch (e) {
      var prefix = currency === "USD" ? "$" : currency + " ";
      return prefix + value.toFixed(fractionDigits).replace(/\.00$/, "");
    }
  }

  function formatUsdCentsForPresentment(usdCents, rate, roundMode) {
    var localCents = Math.max(0, Math.round(usdCents * rate));
    var roundedUnits = roundMode === "ceil" ? Math.ceil(localCents / 100) : Math.round(localCents / 100);
    var localUnits = usdCents > 0 ? Math.max(1, roundedUnits) : 0;
    return formatCurrencyUnits(localUnits, 0);
  }

  var CODE_RATES = { WILDFOOL10: 0.10, WILDFINAL15: 0.15 };
  function sessionCodeRate() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
      if (!m) return 0;
      var code = decodeURIComponent(m[1]).toUpperCase();
      if (CODE_RATES[code] != null) return CODE_RATES[code];
      if (code.indexOf("WELCOME") === 0) return 0.15;
      return 0.10;
    } catch (e) { return 0; }
  }

  function getCartQualification(cart) {
    var qualifyingTotal = 0;
    var ownCount = 0;
    (cart.items || []).forEach(function (item) {
      if (isGift(item)) return;
      if (item.handle === "shipping-protection") return; // WF: exclude shipping protection from gift/threshold math
      qualifyingTotal += item.line_price || 0;
      ownCount += item.quantity || 0;
    });

    var rate = shopCurrencyRate();
    var shopTotal = rate === 1 ? qualifyingTotal : Math.round(qualifyingTotal / rate);
    // v15.2: line_price is ALREADY the discounted amount Shopify charges.
    // The old code multiplied by the discount rate a second time (double-discount),
    // pushing buyers below their tier. Gifts still qualify on discounted spend.
    var effectiveTotal = shopTotal;
    return {
      presentmentTotal: qualifyingTotal,
      shopTotal: shopTotal,
      effectiveTotal: effectiveTotal,
      ownCount: ownCount,
      rate: rate
    };
  }

  function ensureStatus(item) {
    var status = item.querySelector("[data-wf-rewards-status], .wf-rewards__status");
    if (status) return status;
    var right = item.querySelector(".wf-rewards__right");
    if (!right) return null;
    status = document.createElement("span");
    status.className = "wf-rewards__status";
    status.setAttribute("data-wf-rewards-status", "");
    right.appendChild(status);
    return status;
  }

  function setRewardItem(root, key, unlocked, valueText, statusText, superseded) {
    var item = root.querySelector('[data-wf-reward="' + key + '"]');
    if (!item) return;

    item.classList.toggle("is-unlocked", !!unlocked);
    item.classList.toggle("is-superseded", !!superseded);

    var marker = item.querySelector("[data-wf-rewards-marker], .wf-rewards__marker");
    if (marker) {
      var iconKey = unlocked ? "open" : "closed";
      if (marker.getAttribute("data-wf-rendered-lock") !== iconKey) {
        var lockUrl = root.getAttribute("data-wf-lock-img");
        var checkUrl = root.getAttribute("data-wf-check-img");
        if (lockUrl && checkUrl) {
          marker.innerHTML = '<img src="' + (unlocked ? checkUrl : lockUrl) + '" alt="" width="18" height="18">';
        } else {
          marker.innerHTML = unlocked ? OPEN_LOCK_SVG : CLOSED_LOCK_SVG;
        }
        marker.setAttribute("data-wf-rendered-lock", iconKey);
      }
    }

    var value = item.querySelector("[data-wf-rewards-value], .wf-rewards__value");
    if (value && valueText) value.textContent = valueText;

    var status = ensureStatus(item);
    if (status) {
      status.textContent = statusText || "";
      status.style.display = statusText ? "" : "none";
    }
  }

  function replaceCartMojibake(root) {
    try {
      var targets = [];
      if (root) targets.push(root);
      document.querySelectorAll("cart-items-component, cart-drawer-component, .cart, [data-wildfool-rewards]").forEach(function (el) {
        targets.push(el);
      });

      targets.forEach(function (target) {
        if (!target) return;
        var walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT);
        var node;
        while ((node = walker.nextNode())) {
          if (node.nodeValue && node.nodeValue.indexOf("\u8def") !== -1) {
            node.nodeValue = node.nodeValue.replace(/\u8def/g, "\u00b7");
          }
        }
      });
    } catch (e) {}
  }

  function renderRewardUI(cart, qualification) {
    try {
      var q = qualification || getCartQualification(cart);
      var rate = q.rate;
      var roots = document.querySelectorAll("[data-wildfool-rewards]");
      if (!roots.length) return;

      var shippingUnlocked = q.shopTotal >= FREE_SHIPPING_THRESHOLD;
      var shippingNeed = Math.max(0, FREE_SHIPPING_THRESHOLD - q.shopTotal);
      var shippingProgress = Math.max(0, Math.min(100, Math.round(q.shopTotal * 100 / FREE_SHIPPING_THRESHOLD)));
      var shippingThresholdText = formatUsdCentsForPresentment(FREE_SHIPPING_THRESHOLD, rate);
      var shippingNeedText = formatUsdCentsForPresentment(shippingNeed, rate, "ceil");

      var bundleUnlocked = q.shopTotal >= BUNDLE_SUBTOTAL_THRESHOLD;
      var activeGift = currentTier(q.effectiveTotal);
      var activeGiftKey = activeGift ? activeGift.key : null;
      var activeCount = (bundleUnlocked ? 1 : 0) + (activeGiftKey ? 1 : 0);

      roots.forEach(function (root) {
        var headline = root.querySelector("[data-wf-rewards-headline], .wf-rewards__headline");
        if (headline) {
          headline.textContent = "";
          if (shippingUnlocked) {
            headline.appendChild(document.createTextNode("Free shipping "));
            var included = document.createElement("em");
            included.textContent = "included";
            headline.appendChild(included);
          } else {
            headline.appendChild(document.createTextNode("You're "));
            var away = document.createElement("em");
            away.textContent = shippingNeedText + " away";
            headline.appendChild(away);
            headline.appendChild(document.createTextNode(" from free shipping"));
          }
        }

        var fill = root.querySelector("[data-wf-rewards-bar-fill], .wf-rewards__bar-fill");
        if (fill) fill.style.width = shippingProgress + "%";

        var barStart = root.querySelector("[data-wf-rewards-bar-start]");
        if (barStart) barStart.textContent = formatUsdCentsForPresentment(0, rate);

        var barEnd = root.querySelector("[data-wf-rewards-bar-end]");
        if (barEnd) barEnd.textContent = shippingThresholdText + " \u00b7 Free Shipping";

        var count = root.querySelector("[data-wf-rewards-count], .wf-rewards__toggle-count");
        if (count) count.textContent = activeCount + " rewards active";

        TIERS.forEach(function (tier, index) {
          var unlocked = activeGiftKey === tier.key;
          var superseded = !unlocked && q.effectiveTotal >= tier.threshold; // ????????????
          var statusText = "";
          if (!unlocked) {
            if (q.effectiveTotal < tier.threshold) {
              statusText = formatUsdCentsForPresentment(tier.threshold - q.effectiveTotal, rate, "ceil") + " more";
            } else if (superseded) {
              statusText = "Upgraded";
            }
          }
          setRewardItem(root, tier.key, unlocked, formatUsdCentsForPresentment(tier.value, rate) + " value", statusText, superseded);
        });

        /* v15.6: one-line active summary under the collapsed toggle */
        try {
          var act = root.parentElement ? root.parentElement.querySelector("[data-wf-rewards-active]") : null;
          if (!act) act = document.querySelector("[data-wf-rewards-active]");
          if (act) {
            var bits = [];
            if (activeGiftKey) {
              var g = null;
              TIERS.forEach(function (t) { if (t.key === activeGiftKey) g = t; });
              if (g) bits.push("✓ Free " + g.name + " in your cart");
            }
            if (bundleUnlocked) bits.push("✓ 20% bundle discount active");
            else {
              var cr = sessionCodeRate();
              if (cr > 0) bits.push("✓ " + Math.round(cr * 100) + "% code active");
            }
            act.textContent = bits.join("  ·  ");
            act.hidden = bits.length === 0;
          }
        } catch (e) {}

        setRewardItem(
          root,
          "bundle",
          bundleUnlocked,
          formatUsdCentsForPresentment(BUNDLE_SUBTOTAL_THRESHOLD, rate) + "+",
          bundleUnlocked ? "" : formatUsdCentsForPresentment(Math.max(0, BUNDLE_SUBTOTAL_THRESHOLD - q.shopTotal), rate, "ceil") + " more"
        );
        replaceCartMojibake(root);
      });
    } catch (e) {}
  }

  function polishRewardCopy(cart, qualification) {
    try {
      var count = document.querySelector(".wf-rewards__toggle-count");
      if (count) {
        count.textContent = count.textContent.replace("of 4 active", "rewards active");
      }
      document.querySelectorAll(".wf-rewards__value").forEach(function (el) {
        var text = (el.textContent || "").trim();
        if (text === "$55-$199") el.textContent = "$12 value";
        if (text === "$200-$299") el.textContent = "$22 value";
        if (text === "$300+") el.textContent = "$38 value";
      });
      document.querySelectorAll(".wf-rewards__status").forEach(function (el) {
        if ((el.textContent || "").trim().toLowerCase() === "upgraded") el.textContent = "Next tier";
      });
      if (cart) renderRewardUI(cart, qualification);
      replaceCartMojibake();
    } catch (e) {}
  }

  function isGift(item) {
    if (!item) return false;
    if (GIFT_VARIANTS.indexOf(item.variant_id) === -1) return false;
    var p = item.properties;
    if (!p) return false;
    return p[GIFT_PROP_KEY] === "true" || p[GIFT_PROP_KEY] === true;
  }

  // /cart.js returns PRESENTMENT (buyer-local) currency. Convert back to
  // shop currency so the tier threshold matches how Shopify evaluates the
  // native "free gift" discount (which uses shop-currency equivalent).
  function shopCurrencyRate() {
    try {
      var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
      return (r && r > 0) ? r : 1;
    } catch (e) { return 1; }
  }

  function currentTier(total) {
    var selected = null;
    TIERS.forEach(function (t) {
      if (total >= t.threshold) selected = t;
    });
    return selected;
  }

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        lastCartItems = cart.items || [];
        lastCartFetch = Date.now();
        lastCartData = cart;
        return cart;
      });
  }

  function refreshCartSection() {
    // v15.4: dispatch the theme's own cart:update event. Horizon's
    // CartItemsComponent (drawer + cart page) listens for it and re-renders
    // itself via sectionRenderer.renderSection({cache:false}) with a morph -
    // the drawer stays open and the gift line shows up instantly.
    try {
      document.dispatchEvent(new CustomEvent("cart:update", {
        bubbles: true,
        detail: { resource: null, sourceId: "wildfool-gift", data: { source: "wildfool-gift" } }
      }));
      log("cart:update dispatched");
    } catch (e) { log("cart:update dispatch failed", e); }
    return Promise.resolve(true);
  }

  function addGiftVariant(variantId) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: (function () { var p = {}; p[GIFT_PROP_KEY] = "true"; return p; })()
        }]
      })
    }).then(function (r) { return r.json(); });
  }

  function removeGift(lineKey) {
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  function sync(force) {
    var now = Date.now();
    if (syncing) return syncPromise || Promise.resolve();
    if (!force && now - lastSync < 400) return syncPromise || Promise.resolve();
    syncing = true;
    lastSync = now;

    syncPromise = fetchCart()
      .then(function (cart) {
        var qualification = getCartQualification(cart);
        var giftLines = {};
        var customerOwn = {};
        cart.items.forEach(function (item) {
          if (isGift(item)) {
            giftLines[item.variant_id] = item;
          } else {
            if (GIFT_VARIANTS.indexOf(item.variant_id) !== -1) {
              customerOwn[item.variant_id] = item;
            }
          }
        });

        var target = currentTier(qualification.effectiveTotal);
        polishRewardCopy(cart, qualification);
        if (!debugLogged) {
          debugLogged = true;
          log("loaded. cart:", cart.items.length, "items / presentment " + (qualification.presentmentTotal / 100).toFixed(2), "/ shop-eq $" + (qualification.shopTotal / 100).toFixed(2), "(rate " + qualification.rate + ") / target", target ? target.name : "none");
        }

        var chain = Promise.resolve();
        var didChange = false;

        GIFT_VARIANTS.forEach(function (variantId) {
          chain = chain.then(function () {
            var isTarget = !!target && target.variantId === variantId;
            var line = giftLines[variantId];
            if (line && !isTarget) {
              log("removing lower/non-qualifying gift", variantId);
              didChange = true;
              return removeGift(line.key);
            }
          });
        });

        chain = chain.then(function () {
          if (!target) return;
          var giftLine = giftLines[target.variantId];
          var hasGiftLine = !!giftLine;
          var customerHasOwn = !!customerOwn[target.variantId];

          // v14: the discount engine did not zero this gift (threshold mismatch
          // in buyer currency) -> never charge the buyer, remove and hold.
          if (giftLine && (giftLine.final_line_price || 0) > 0) {
            log("gift line is not free (" + giftLine.final_line_price + "); removing + hold", target.variantId);
            setPriceHold(target.variantId, qualification.effectiveTotal);
            didChange = true;
            return removeGift(giftLine.key);
          }

          if (customerHasOwn) {
            if (hasGiftLine) {
              log("dedup " + target.name + " (customer added own; removing gift line)");
              didChange = true;
              return removeGift(giftLine.key);
            }
            return;
          }

          if (!hasGiftLine) {
            if (giftDismissed()) {
              log("skip add: customer dismissed gift this session");
              return;
            }
            if (heldAtCurrentTotal(target.variantId, qualification.effectiveTotal)) {
              log("skip add: price hold active for", target.variantId);
              return;
            }
            if (qualification.effectiveTotal < target.threshold + ADD_MARGIN) {
              log("skip add: within rounding margin of threshold", target.threshold);
              return;
            }
            log("adding " + target.name + " (highest eligible gift)");
            didChange = true;
            return addGiftVariant(target.variantId);
          }
        });

        return chain.then(function () {
          if (!didChange) return;
          return Promise.all([refreshCartSection(), fetchCart()])
            .then(function (pair) { return pair[1]; })
            .then(function (updatedCart) {
              // v14: verify a just-added gift actually came in free.
              var charged = (updatedCart.items || []).filter(function (it) {
                return isGift(it) && (it.final_line_price || 0) > 0;
              });
              if (charged.length) {
                var q2 = getCartQualification(updatedCart);
                var removals = Promise.resolve();
                charged.forEach(function (it) {
                  log("gift came in charged (" + it.final_line_price + "); removing + hold", it.variant_id);
                  setPriceHold(it.variant_id, q2.shopTotal);
                  removals = removals.then(function () { return removeGift(it.key); });
                });
                return removals
                  .then(refreshCartSection)
                  .then(fetchCart)
                  .then(function (cart2) {
                    polishRewardCopy(cart2, getCartQualification(cart2));
                  });
              }
              polishRewardCopy(updatedCart, getCartQualification(updatedCart));
            })
            .catch(function () {
              polishRewardCopy(cart, qualification);
            });
        });
      })
      .catch(function (e) { log("sync failed", e); })
      .then(function () {
        syncing = false;
        syncPromise = null;
        cartDirty = false; // v15.5: cart settled - checkout guard stands down
      });
    return syncPromise;
  }

  if (typeof window.fetch !== "function") return;

  var origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : input && input.url ? input.url : "";
    var body = init && init.body ? String(init.body) : "";
    var isCartMutation = /\/cart\/(add|change|update|clear)/.test(url);

    var isOurCall = body.indexOf(GIFT_PROP_KEY) !== -1;
    GIFT_VARIANTS.forEach(function (vid) {
      if (
        body.indexOf('"id":"' + vid + ':') !== -1 ||
        body.indexOf('"id": "' + vid + ':') !== -1
      ) {
        isOurCall = true;
      }
    });

    // v14: recognise "customer removed the gift line" before syncing, so
    // sync() will not immediately re-add it (the old infinite loop).
    if (isCartMutation && !isOurCall && body) {
      try {
        var parsed = JSON.parse(body);
        var removedGift = false;
        var qty = parsed && parsed.quantity;
        if (qty === 0 || qty === "0") {
          if (parsed.line != null && lastCartItems) {
            var lineItem = lastCartItems[Number(parsed.line) - 1];
            if (isGift(lineItem)) removedGift = true;
          }
          if (typeof parsed.id === "string") {
            GIFT_VARIANTS.forEach(function (vid) {
              if (parsed.id.indexOf(vid + ":") === 0) removedGift = true;
            });
          }
        }
        if (parsed && parsed.updates && typeof parsed.updates === "object") {
          Object.keys(parsed.updates).forEach(function (k) {
            if (Number(parsed.updates[k]) !== 0) return;
            GIFT_VARIANTS.forEach(function (vid) {
              if (k === String(vid) || k.indexOf(vid + ":") === 0) removedGift = true;
            });
          });
        }
        if (removedGift) setGiftDismissed();
      } catch (e) {}
    }

    var result = origFetch(input, init);
    if (isCartMutation && !isOurCall) {
      cartDirty = true;
      cartWriteVersion += 1;
      lastCartWriteError = null;
      var write = result.then(function (response) {
        if (!response.ok) throw new Error("Cart update failed");
        return response;
      });
      pendingCartWrites.add(write);
      write.then(function () {
        pendingCartWrites.delete(write);
        if (!pendingCartWrites.size) setTimeout(sync, 0);
      }, function (error) {
        pendingCartWrites.delete(write);
        lastCartWriteError = error;
      });
    }
    return result;
  };

  function findCheckoutTrigger(el) {
    if (!el || !el.closest) return null;
    return el.closest(
      'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [type="submit"][name="checkout"], .cart__checkout-button, .shopify-payment-button__button'
    );
  }

  function isCheckoutTrigger(el) {
    return !!findCheckoutTrigger(el);
  }

  function continueCheckout(trigger) {
    checkoutGuardBypass = true;
    try {
      var link = trigger && trigger.closest && trigger.closest('a[href*="/checkout"]');
      if (link && link.href) {
        window.location.href = link.href;
        return;
      }

      var form = trigger && (trigger.form || (trigger.closest && trigger.closest("form")));
      if (form && !form.isConnected) form = document.getElementById(form.id);
      if (form) {
        if (trigger.name && !form.querySelector('input[type="hidden"][name="' + trigger.name + '"]')) {
          var input = document.createElement("input");
          input.type = "hidden";
          input.name = trigger.name;
          input.value = trigger.value || "";
          form.appendChild(input);
        }
        form.submit();
        return;
      }

      window.location.href = "/checkout";
    } finally {
      setTimeout(function () { checkoutGuardBypass = false; }, 1200);
    }
  }

  function waitForCartWrites() {
    return Promise.all(Array.from(pendingCartWrites)).then(function () {
      if (lastCartWriteError) throw lastCartWriteError;
      var version = cartWriteVersion;
      return sync(true).then(function () {
        if (pendingCartWrites.size || version !== cartWriteVersion) return waitForCartWrites();
        if (lastCartWriteError) throw lastCartWriteError;
      });
    });
  }

  function settleThenCheckout(trigger) {
    if (checkoutPending) return;
    checkoutPending = true;
    if (trigger) trigger.setAttribute("aria-busy", "true");
    waitForCartWrites().then(function () {
      continueCheckout(trigger);
    }).catch(function () {
      var message = document.getElementById("wf-cart-update-error");
      if (!message) {
        message = document.createElement("p");
        message.id = "wf-cart-update-error";
        message.setAttribute("role", "alert");
        var anchor = trigger && trigger.isConnected ? trigger : document.querySelector(".cart__checkout-button");
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(message, anchor);
      }
      message.textContent = "Your cart update did not finish. Please try applying your discount again before checking out.";
    }).finally(function () {
      checkoutPending = false;
      if (trigger) trigger.removeAttribute("aria-busy");
    });
  }

  function guardCheckout(ev) {
    if (checkoutGuardBypass) return;
    var trigger = findCheckoutTrigger(ev.target);
    if (!trigger) return;
    if (!syncing && !cartDirty && !pendingCartWrites.size && !lastCartWriteError) return;

    ev.preventDefault();
    ev.stopPropagation();
    log("checkout held for gift sync");
    settleThenCheckout(trigger);
  }

  function guardCartSubmit(ev) {
    if (checkoutGuardBypass) return;
    var submitter = ev.submitter || document.activeElement;
    if (!isCheckoutTrigger(submitter)) return;
    if (!syncing && !cartDirty && !pendingCartWrites.size && !lastCartWriteError) return;

    ev.preventDefault();
    ev.stopPropagation();
    log("cart submit held for gift sync");
    settleThenCheckout(submitter);
  }

  function installCheckoutGuard() {
    document.addEventListener("click", guardCheckout, true);
    document.addEventListener("submit", guardCartSubmit, true);
  }

  function init() { installCheckoutGuard(); polishRewardCopy(); setTimeout(function () { polishRewardCopy(); sync(); }, 0); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // ?? ??: ??????? / ??????, ??????(? page-load + ????) ??
  var rerenderT = null;
  function stopObserve() { try { if (mo) mo.disconnect(); } catch (e) {} }
  function startObserve() { try { if (mo) mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {} }
  function paintRewards(cart) {
    // v15.2: pause the observer while we mutate the DOM. Otherwise our own
    // render re-triggers it -> fetchCart -> render -> ... (request storm).
    rerenderBusy = true;
    stopObserve();
    try { renderRewardUI(cart, getCartQualification(cart)); } catch (e) {}
    startObserve();
    rerenderBusy = false;
  }
  function rerenderRewards() {
    if (rerenderBusy) return;
    clearTimeout(rerenderT);
    rerenderT = setTimeout(function () {
      if (rerenderBusy) return;
      // v15.2: reuse a cart fetched within the last second instead of re-fetching
      if (lastCartData && Date.now() - lastCartFetch < 1000) { paintRewards(lastCartData); return; }
      rerenderBusy = true;
      fetchCart().then(function (cart) {
        rerenderBusy = false;
        paintRewards(cart);
      }).catch(function () { rerenderBusy = false; });
    }, 150);
  }
  ["cart:update", "cart:refresh", "cart:updated", "cart:change"].forEach(function (ev) {
    document.addEventListener(ev, rerenderRewards);
  });
  // ??? rewards snippet ???? DOM (?? Liquid ?????) -> ???
  try {
    mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && ((n.matches && n.matches("[data-wildfool-rewards]")) || (n.querySelector && n.querySelector("[data-wildfool-rewards]")))) {
            rerenderRewards();
            return;
          }
        }
      }
    });
    startObserve();
  } catch (e) {}
  // ?? header ??? / ????
  document.addEventListener("click", function (e) {
    if (e.target.closest('a[href="/cart"], a[href*="/cart"], [data-cart-toggle], .header__cart-link, #cart-icon-bubble, cart-drawer-component')) {
      setTimeout(rerenderRewards, 320);
    }
  }, true);
})();

/* ===== WF-SHIP-PROTECT-WIRE (cart toggle -> add/remove $2.50 protection) ===== */
;(function(){
  var PV = 53447279640941, PH = "shipping-protection";
  function sync(){ fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ var has=(c.items||[]).some(function(i){return i.handle===PH;}); document.querySelectorAll('.wf-sp__cb').forEach(function(x){ if(x.checked!==has) x.checked=has; }); }).catch(function(){}); }
  /* v15.5: refresh drawer/page section in place (cart:update morph) instead of full reload */
  function refresh(t){
    try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: null, sourceId: 'wf-ship-protect', data: { source: 'wf-ship-protect' } } })); } catch (e) {}
    setTimeout(function(){ if (t && t.removeAttribute) t.removeAttribute('data-wf-busy'); sync(); }, 600);
  }
  document.addEventListener('change', function(e){
    var t=e.target; if(!t||!t.classList||!t.classList.contains('wf-sp__cb')) return;
    if(t.getAttribute('data-wf-busy')) return; t.setAttribute('data-wf-busy','1');
    if(t.checked){
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ var it=(c.items||[]).filter(function(i){return i.handle===PH;})[0]; if(!it){ return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:PV,quantity:1}]})}); } if(it.quantity!==1){ return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:it.key,quantity:1})}); } }).then(function(){refresh(t);}).catch(function(){refresh(t);});
    } else {
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ var it=(c.items||[]).filter(function(i){return i.handle===PH;})[0]; if(it){ return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:it.key,quantity:0})}); } }).then(function(){refresh(t);}).catch(function(){refresh(t);});
    }
  }, false);
  if(document.readyState!=='loading') sync(); else document.addEventListener('DOMContentLoaded',sync);
  document.addEventListener('shopify:section:load', sync);
})();
